import styledComp from 'styled-components';
import { Styling, Colors } from '../../constants';

export const loadingIndicatorHeigth = 4;

export const Container = styledComp.div`
  background: ${Colors.WHITE_100};
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  font-size: 14px;
  padding: ${Styling.DEFAULT_SPACING - loadingIndicatorHeigth}px ${Styling.DEFAULT_SPACING}px ${Styling.DEFAULT_SPACING}px;
  width: 100%;
`;

export const LoadingIndicatorContainer = styledComp.div`
  height: ${loadingIndicatorHeigth}px;
  width: 100%;
`;

export const FadeDivWrapper = styledComp.div`
  display: contents;
`;
